module.exports = __webpack_public_path__ + "img/logo-big-white.cc59f10b.png";